import React, { useRef, useEffect } from 'react';

const formatTime = (iso) => {
  if (!iso) return '';
  const d = new Date(iso);
  const now = new Date();
  const diff = now - d;
  if (diff < 60000) return 'Just now';
  if (diff < 3600000) return `${Math.floor(diff / 60000)}m ago`;
  if (diff < 86400000) return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
  return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

const WatchRefCard = ({ watch }) => (
  <div className="flex items-center gap-2 p-2 rounded-lg bg-muted/40 border border-border/50 mt-1 max-w-[240px]" data-testid="watch-ref-card">
    {watch.image && <img src={watch.image} alt={watch.name} className="w-10 h-10 rounded object-cover shrink-0" />}
    <div className="min-w-0">
      <p className="text-xs font-medium truncate">{watch.name}</p>
      <p className="text-xs text-[#D0B36B]">${watch.price?.toLocaleString()}</p>
    </div>
  </div>
);

const MessageBubble = ({ msg, isAdmin }) => (
  <div className={`flex ${isAdmin ? 'justify-end' : 'justify-start'} mb-3`} data-testid={`msg-${msg.id}`}>
    <div className="max-w-[75%]">
      <div className={`px-3 py-2 rounded-2xl text-sm whitespace-pre-line ${
        msg.sender_name === 'System'
          ? 'bg-yellow-500/10 text-yellow-200 border border-yellow-500/20 rounded-lg text-xs'
          : isAdmin ? 'bg-primary/15 text-foreground rounded-br-md' : 'bg-muted/60 text-foreground rounded-bl-md'
      }`}>
        {msg.content}
      </div>
      {msg.watch_ref && <WatchRefCard watch={msg.watch_ref} />}
      <p className={`text-[10px] text-muted-foreground mt-0.5 ${isAdmin ? 'text-right' : ''}`}>
        {msg.sender_name} · {formatTime(msg.created_at)}
      </p>
    </div>
  </div>
);

const MessageList = ({ messages }) => {
  const endRef = useRef(null);
  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  return (
    <div className="flex-1 overflow-y-auto px-4 py-4" data-testid="message-list">
      {messages.map(m => <MessageBubble key={m.id} msg={m} isAdmin={m.sender_role === 'admin'} />)}
      <div ref={endRef} />
    </div>
  );
};

export default MessageList;
